import { render, staticRenderFns } from "./mention-users.vue?vue&type=template&id=138fa21c"
import script from "./mention-users.vue?vue&type=script&lang=js"
export * from "./mention-users.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./mention-users.vue?vue&type=style&index=1&id=138fa21c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports